import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareAuthHeaders } from '../../utils/prepareAuthHeaders';

export const reportsApi = createApi({
  reducerPath: 'reportsApi',
  keepUnusedDataFor: 1,
  baseQuery: fetchBaseQuery({
    baseUrl: '/Reports',
    prepareHeaders: prepareAuthHeaders,
    paramsSerializer: (params) => new URLSearchParams(
      Object.entries(params).filter(([, value]) => value !== null && value !== undefined)
        .map(([key, value]) => [key, value instanceof Date ? value.toISOString() : value])
    ).toString(),
  }),
  endpoints: (builder) => ({
    debtorStudentsWebReport: builder.mutation({
      query: ({ data }) => ({
        url: `/DebtorStudentsWebReport`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['Post'],
    }),
    practiceDebtorStudentsWebReport: builder.query({
      query: ({ data }) => ({
        url: `/PracticeDebtorStudentsWebReport`,
        method: 'GET',
        params: data
      }),
    }),
    examsStatisticsWebReport: builder.query({
      query: ({ data }) => ({
        url: `/ExamsStatisticsWebReport`,
        method: 'GET',
        params: data
      }),
    }),
    financeFormsList: builder.query({
      query: () => ({
        url: `/FinanceFormsList`,
        method: 'GET'
      }),
    }),
    saveFinanceForms: builder.mutation({
      query: ({ data }) => ({
        url: `/SaveFinanceForms`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['Post'],
    }),
    sessionResultsWebReport: builder.query({
      query: ({ data }) => ({
        url: `/SessionResultsWebReport`,
        method: 'GET',
        params: data
      }),
    }),
    academicStipendWebReport: builder.query({
      query: ({ data }) => ({
        url: `/AcademicStipendWebReport`,
        method: 'GET',
        params: data
      }),
    }),
    sessionStatisticsWebReport: builder.query({
      query: ({ data }) => ({
        url: `/SessionStatisticsWebReport`,
        method: 'GET',
        params: data
      }),
    }),
    overdueStatementsWebReport: builder.query({
      query: ({ data }) => ({
        url: `/OverdueStatementsWebReport`,
        method: 'GET',
        params: data
      }),
    }),
    retakesStatisticsOverTheUniversityWebReport: builder.query({
      query: ({ data }) => ({
        url: `/RetakesStatisticsOverTheUniversityWebReport`,
        method: 'GET',
        params: data
      }),
    }),
    averageEmployeeGradesOverTheDisciplinesWebReport: builder.query({
      query: ({ data }) => ({
        url: `/AverageEmployeeGradesOverTheDisciplinesWebReport`,
        method: 'GET',
        params: data
      }),
    }),
    practicesRetakesStatisticsWebReport: builder.query({
      query: () => ({
        url: `/PracticesRetakesStatisticsWebReport`,
        method: 'GET'
      }),
    }),
    notAllowedStudentsWebReport: builder.query({
      query: ({ data }) => ({
        url: `/NotAllowedStudentsWebReport`,
        method: 'GET',
        params: data
      }),
    }),
    sessionResultsAtTheMomentOfPassingByChairWebReport: builder.query({
      query: ({ data }) => ({
        url: `/SessionResultsAtTheMomentOfPassingByChairWebReport`,
        method: 'GET',
        params: data
      }),
    }),
    sessionResultsAtTheMomentOfPassingByFacultyGroupsWebReport: builder.query({
      query: ({ data }) => ({
        url: `/SessionResultsAtTheMomentOfPassingByFacultyGroupsWebReport`,
        method: 'GET',
        params: data
      }),
    }),
    sessionResultsAtTheMomentOfPassingByEmployeesWebReport: builder.query({
      query: ({ data }) => ({
        url: `/SessionResultsAtTheMomentOfPassingByEmployeesWebReport`,
        method: 'GET',
        params: data
      }),
    }),
    academicPerformanceByPeriodWebReport: builder.query({
      query: ({ data }) => ({
        url: `/AcademicPerformanceByPeriodWebReport`,
        method: 'GET',
        params: data
      }),
    }),
    attendanceByGroupWebReport: builder.mutation({
      query: ({ data }) => ({
        url: `/AttendanceByGroupWebReport`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['Post'],
    }), 
    getNumberOfAttendanceByStudentsEntities: builder.mutation({
      query: ({ data }) => ({
        url: `/GetNumberOfAttendanceByStudentsEntities`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['Post'],
    }),
    attestationDebtorStudentsWebReport: builder.query({
      query: ({ data }) => ({
        url: `/AttestationDebtorStudentsWebReport`,
        method: 'GET',
        params: data
      }),
    }),
    attendanceMonitoringReport: builder.mutation({
      query: ({ data }) => ({
        url: `/AttendanceMonitoringReport`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['Post'],
    }),
  }),
});

export const {
  useDebtorStudentsWebReportMutation,
  useLazyPracticeDebtorStudentsWebReportQuery,
  useLazyExamsStatisticsWebReportQuery,
  useFinanceFormsListQuery,
  useSaveFinanceFormsMutation,
  useLazySessionResultsWebReportQuery,
  useLazyAcademicStipendWebReportQuery,
  useLazySessionStatisticsWebReportQuery,
  useLazyOverdueStatementsWebReportQuery,
  useLazyRetakesStatisticsOverTheUniversityWebReportQuery,
  useLazyAverageEmployeeGradesOverTheDisciplinesWebReportQuery,
  useLazyPracticesRetakesStatisticsWebReportQuery,
  useLazyNotAllowedStudentsWebReportQuery,
  useLazySessionResultsAtTheMomentOfPassingByChairWebReportQuery,
  useLazySessionResultsAtTheMomentOfPassingByFacultyGroupsWebReportQuery,
  useLazySessionResultsAtTheMomentOfPassingByEmployeesWebReportQuery,
  useLazyAcademicPerformanceByPeriodWebReportQuery,
  useAttendanceByGroupWebReportMutation,
  useGetNumberOfAttendanceByStudentsEntitiesMutation,
  useLazyAttestationDebtorStudentsWebReportQuery,
  useAttendanceMonitoringReportMutation
} = reportsApi;
